module.exports = __webpack_public_path__ + "static/media/hs_24.1f445c1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_24.jpg
// module id = 5954
// module chunks = 0